import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=62563499&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=js"
export * from "./shopDetail.vue?vue&type=script&lang=js"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=62563499&prod&lang=less&scoped=true"
import style1 from "./shopDetail.vue?vue&type=style&index=1&id=62563499&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62563499",
  null
  
)

export default component.exports